import React, {useCallback, useMemo} from 'react';
import {useSideBarModal} from '../../../../layout/common/useSideBarModal';
import SideBarModal from '../../../../layout/common/SideBarModal';
import VisualizationAnalysisSave, {VisualizationSaveProps} from './VisualizationAnalysisSave';

export const useVisualizationAnalysisSaveSideBarModal = (props: Partial<VisualizationSaveProps>) => {
  const {model, subModel, scenario, onSuccess} = props;
  const {buttonRef, openModal, closeModal} = useSideBarModal(model, scenario);

  const handleSuccess = useCallback(() => {
    closeModal();
    onSuccess?.();
  }, [closeModal, onSuccess]);

  const ModalComponent = useMemo(() => {
    return (
      model &&
      subModel &&
      scenario && (
        <SideBarModal
          height={350}
          className="whiteTheme"
          isOpen={!!buttonRef}
          buttonRef={buttonRef}
          closeModal={closeModal}
        >
          <div style={{width: '40rem', paddingLeft: '3rem'}}>
            {!!buttonRef && (
              <VisualizationAnalysisSave
                model={model}
                subModel={subModel}
                scenario={scenario}
                onCancel={closeModal}
                onSuccess={handleSuccess}
              />
            )}
          </div>
        </SideBarModal>
      )
    );
  }, [buttonRef, closeModal, model, subModel, scenario, handleSuccess]);

  return {
    openModal,
    ModalComponent,
  };
};
